export const FUNC_POINTS_COUNT_FROM_OBJECT = `pointsCountFromObject`;
export const FUNC_CORE_PRIMITIVE_CLASS_FACTORY = `corePrimitiveClassFactory`;
